// eslint-disable-next-line no-restricted-imports
import { Tree as AntdTree } from 'antd';
import styled from 'styled-components';

export const Tree = styled(AntdTree)`
  .icon-shell.ant-tree-switcher-icon {
    display: flex;
    align-items: center;
  }
`;
